import { useSelector } from 'react-redux';
import { paths, siteAuditMenuHeadings } from 'src/common/config/TextMessage';
import { RootState } from 'src/redux/store';

/**
 * Generates a menu based on the user's plan.
 *
 * @param {object} plan - The user's subscription plan.
 * @returns {Array} An array of menu items.
 */
export const menu = (plan) => {
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  let activePlanName =
    useSelector((state: RootState) => state.user.activePlan) || 'logout';

  let defaultMenu = [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: '/dashboard.svg',
      endIcon: '',
      classOption: 'topOption'
    },
    {
      title: 'Site Audit',
      url: '/site-audit',
      icon: '/siteaudit.svg',
      endIcon: ''
    },

    {
      title: 'Lead Generation',
      url: '/lead-generation',
      icon: '/leadgeneration.svg',
      endIcon: ''
    },
    {
      title: 'Keyword Research',
      url: '/keyword-research',
      icon: '/Key.svg',
      endIcon: ''
    },
    {
      title: 'Orbit AI',
      url: '/orbit-ai-agent',
      icon: '/ai-visibility.svg',
      endIcon: ''
    },

    {
      title: 'Backlink Analysis',
      url: '/backlinks',
      icon: '/Chart 2.svg',
      endIcon: ''
    },
    {
      title: 'Local SEO',
      url: '/local-seo',
      icon: '/map.svg',
      endIcon: ''
    },

    {
      title: '',
      url: '',
      icon: '',
      endIcon: ''
    }

  ];
  let defaultFreeMenu = [
    {
      title: 'External Scans',
      url: '/external-scans',
      icon: '/siteaudit.svg',
      endIcon: ''
    },
    {
      title: siteAuditMenuHeadings?.aiVisibility,
      url: paths.aiVisibility,
      icon: '/ai-visibility.svg',
      endIcon: ''
    },
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: '/dashboard.svg',
      endIcon: '',
      classOption: 'topOption'
    },
    {
      title: 'Site Audit',
      url: '/site-audit',
      icon: '/siteaudit.svg',
      endIcon: ''
    },

    {
      title: 'Keyword Research',
      url: '/keyword-research',
      icon: '/Key.svg',
      endIcon: ''
    },
    {
      title: 'Orbit AI',
      url: '/orbit-ai-agent',
      icon: '/ai-visibility.svg',
      endIcon: ''
    },

    {
      title: 'Backlink Analysis',
      url: '/backlinks',
      icon: '/Chart 2.svg',
      endIcon: ''
    },
    {
      title: 'Local SEO',
      url: '/local-seo',
      icon: '/map.svg',
      endIcon: ''
    },

    {
      title: '',
      url: '',
      icon: '',
      endIcon: ''
    }

  ];
  let defaultLocalSeoPlanMenu = [

    {
      title: 'Business Profile',
      url: paths?.localChecker,
      icon: '/briefcase.svg',
      endIcon: ''
    },
    {
      title: 'Local SEO Tasks',
      url: paths?.localTasks,
      icon: '/clipboard-tick.svg',
      endIcon: ''
    },
    {
      title: 'Google Reviews',
      url: paths?.googleReviews,
      icon: '/star.svg',
      endIcon: ''
    },
    {
      title: 'Listing Manager',
      url: paths?.listingManager,
      icon: '/map.svg',
      endIcon: ''
    },
    {
      title: 'Business Posts',
      url: paths?.businessPosts,
      icon: '/edit-2.svg',
      endIcon: ''
    },
    {
      title: 'Map Rank Tracker',
      url: paths?.mapRankTracker,
      icon: '/map.svg',
      endIcon: ''
    }

  ];
  switch (activePlanName) {
    case planDetails.pro:
      return defaultMenu;
    case planDetails.proPlus:
      return defaultMenu;
    case planDetails.diy:
      return defaultMenu;
    case planDetails.starterPlus:
      return defaultMenu;
    case planDetails.designer:
      return defaultMenu;
    case planDetails.agency:
      return defaultMenu;
    case planDetails.expertPlus:
      return defaultMenu;
    case planDetails.localseo:
      return defaultLocalSeoPlanMenu;
    case planDetails.enterprise:
      return defaultMenu;

    case 'free':
      return defaultFreeMenu;
  }
};
